import { PartyService } from 'src/app/services/api/party/party.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BreadcrumbsService } from 'src/app/services/utils/breadcrumbs.service';
import { CoverageService } from 'src/app/services/api/coverage/coverage.service';
import * as moment from 'moment';
import { NotificationsService, NotificationLevel } from 'src/app/services/api/notifications/notifications.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-coverage-load',
  templateUrl: './coverage-load.component.html',
  styleUrls: ['./coverage-load.component.scss']
})
export class CoverageLoadComponent implements OnInit, OnDestroy {

  isps: string[];
  inos: string[];

  selectedIsps: FormControl;
  selectedIno: string;
  selectedIspForStatus: string;

  fileToUpload: File = null;
  progress: number;

  selectedIspForStateDisabled: boolean;
  indexStates: any;
  uploadState: any;
  indexState: number;
  stateMachineCall: number;
  currentlyUsingDoc: any;
  lastIndexTimestamp: string;
  firstGeneratedIndex: boolean;
  firstUsingIndex: boolean;
  currentIndexBeingUsed: any;
  wildcard: string;
  currentIspForStatus: string;
  ispWildcard: string;
  currentIndexTimestamp: string;
  lastUploadedDoc: any;

  dateFormat: string;
  currentIndices: any[];

  constructor(
    private breadcrumbsService: BreadcrumbsService,
    private coverageService: CoverageService,
    private partyService: PartyService,
    private notificationsService: NotificationsService) {


  }

  ngOnInit() {
    this.selectedIsps = new FormControl([]);
    this.inos = [];
    this.isps = [];

    this.indexStates = {
      UPDATED: 0,
      UPLOADING_FILE: 1,
      CHECKING_INDICES: 2,
      WAITING_FOR_UPDATE: 3
    };

    this.progress = 0;

    this.breadcrumbsService.sendBreadcrumbs(
      {
        breadcrumbs: [
          { title: 'Administración', url: 'provision/management' },
          { title: 'Cobertura FTTH', url: 'provision/management/coverage' },
          { title: 'Carga de cobertura', url: 'provision/management/coverage/load' }]
      }
    );

    this.lastIndexTimestamp = null;
    this.firstGeneratedIndex = true;
    this.firstUsingIndex = true;
    this.indexState = null;
    this.currentIndexBeingUsed = null;
    this.wildcard = null;
    this.uploadState = {
      finished: true,
      percentage: 0,
      state: null,
      message: null,
    }
    this.stateMachineCall = undefined;

    this.dateFormat = 'YYYYMMDDhhmmss';

    this.selectedIspForStateDisabled = true;
    this.indexState = this.indexStates.UPLOADING_FILE;


    this.partyService.getCustomers().subscribe(
      (data) => {
        for (const party of data) {
          this.isps.push(party.name);
        }
        this.partyService.getProviders().subscribe(
          (data) => {
            for (const ino of data) {
              this.inos.push(ino.name);
            }
            this.selectedIspForStatus = this.isps[0].toLowerCase().replace(/[\s]/g, '');
            this.updateState();
          }
        )
      }
    )
  }

  private getIspLastFileQuery(currentIspForStatus: string): any {
    return {
      query: '*-' + currentIspForStatus + '-*',
      fields: ['isps'],
      sort: { fTimestamp: 'desc' },
    };
  }

  private checkIndicesAfterCharge() {

    this.indexState = this.indexStates.CHECKING_INDICES;
    this.stateMachineCall = setTimeout(this.updateState.bind(this), 2000) as any;
  }

  private getTemporalAliasQuery() {
    return [
      { add: { index: this.lastUploadedDoc['indexName'], alias: 'gescal37_temp_' + this.currentIspForStatus } }
    ];
  }

  private getSwapUsingAliasQuery(firstIndex: boolean) {
    if (firstIndex) {
      return [
        { add: { index: this.lastUploadedDoc['indexName'], alias: 'gescal37_current_' + this.currentIspForStatus } }
      ];
    } else {
      return [
        {
          remove:
          {
            index: 'gescal37_*_' + this.lastUploadedDoc['indexName'].split('_')[2] + '_*',
            alias: 'gescal37_current_' + this.currentIspForStatus
          }
        },
        { add: { index: this.lastUploadedDoc['indexName'], alias: 'gescal37_current_' + this.currentIspForStatus } }
      ];
    }
  }


  private getHomeIdSwapUsingAliasQuery(ino, alias, index, firstIndex) {
    if (firstIndex) {
      return [
        { add: { index: index, alias: alias } }
      ];
    } else {
      return [
        { add: { index: index, alias: alias } }
      ];
    }
  }

  private configureHomeIdAliases(ino, newIndexTimestamp) {
    this.coverageService.getIfAliasContainsIndices("homeid_current_" + ino).subscribe(
      (data) => {
        this.coverageService.configAliases(
          this.getHomeIdSwapUsingAliasQuery(ino, "homeid_current_" + ino, "homeid_" + ino + "_" + newIndexTimestamp, false)
        ).subscribe(
          (data) => {
            this.coverageService.setMaxResultWindowIno(ino).subscribe(
              (data) => {
                this.checkIndicesAfterCharge();
              }
            );
          }
        );
      },
      (error) => {
        this.coverageService.configAliases(
          this.getHomeIdSwapUsingAliasQuery(ino, "homeid_current_" + ino, "homeid_" + ino + "_" + newIndexTimestamp, true)
        ).subscribe(
          (data) => {
            this.coverageService.setMaxResultWindowIno(ino).subscribe(
              (data) => {
                this.checkIndicesAfterCharge();
              }
            );
          }
        );
      }
    );
  }

  private getCreatePrioritiesQuery(inos: string[]) {
    return {
      priorities: inos
    };
  }

  private getUpdatePrioritiesQuery(ino: string) {
    return {
      ino
    };
  }

  private solveStateWhenIndicesAreUpdated() {
    if (!this.firstUsingIndex) {
      this.wildcard = 'gescal37_current_' + this.currentIspForStatus;
      this.coverageService.getIndexStats(this.wildcard).subscribe(
        (data) => {
          this.currentlyUsingDoc = data;
          this.currentlyUsingDoc['indexName'] = Object.keys(this.currentlyUsingDoc.indices)[0];
        }
      );
    }
    this.indexState = this.indexStates.UPDATED;
  }

  private solveStateWithoutFilesLoaded() {
    if (this.firstGeneratedIndex) {
      this.indexState = this.indexStates.UPDATED;
    } else {
      this.stateMachineCall = setTimeout(this.updateState.bind(this), 10000) as any;
    }
  }

  public selectedIspForStatusChange() {
    if (this.stateMachineCall !== undefined) {
      clearTimeout(this.stateMachineCall);
    }
    this.currentlyUsingDoc = null;
    this.lastIndexTimestamp = null;
    this.firstGeneratedIndex = true;
    this.firstUsingIndex = true;
    this.indexState = null;
    this.currentIndexBeingUsed = null;
    this.wildcard = null;
    this.selectedIspForStateDisabled = false;
    this.indexState = this.indexStates.CHECKING_INDICES;
    this.stateMachineCall = setTimeout(this.updateState.bind(this), 4000) as any;
  }

  public updateState() {
    if (this.indexState === this.indexStates.UPLOADING_FILE) {
      this.coverageService.getFileUploadState().subscribe(
        (data) => {
          if (data && data['resultado'] === 'OK') {
            if (data['finished'] === false) {
              this.uploadState = data;
              this.stateMachineCall = setTimeout(this.updateState.bind(this), 2000) as any;
            } else {
              this.indexState = this.indexStates.CHECKING_INDICES;
              this.selectedIspForStateDisabled = false;
              this.stateMachineCall = setTimeout(this.updateState.bind(this), 4000) as any;
            }
          } else {
            this.indexState = this.indexStates.CHECKING_INDICES;
            this.uploadState = data;
            this.stateMachineCall = setTimeout(this.updateState.bind(this), 2000) as any;
          }
        },
        (error) => {

        }
      );
    } else if (this.indexState === this.indexStates.CHECKING_INDICES) {

      this.currentIspForStatus = this.selectedIspForStatus;
      this.ispWildcard = '*-' + this.currentIspForStatus + '-*';
      this.wildcard = 'gescal' + this.ispWildcard;
      this.coverageService.getIndex(this.wildcard).subscribe(
        (data) => {
          if (data.length === 0) {
            this.firstGeneratedIndex = true;
          } else {
            this.firstGeneratedIndex = false;
          }
          this.coverageService.getCurrentIndexBeingUsed(this.currentIspForStatus).pipe(
            finalize(
              () => {
                this.coverageService.getIspLastFileLoadedInfo(this.getIspLastFileQuery(this.currentIspForStatus)).subscribe(
                  (data) => {
                    if (data.hits.hits.length === 0) {
                      this.solveStateWithoutFilesLoaded();
                      return;
                    }
                    this.lastIndexTimestamp = data.hits.hits[0]._source.timestamp;
                    this.coverageService.getIndex(this.wildcard).subscribe(
                      (data) => {
                        data.sort((x, y) => {
                          return moment(y.split('_')[y.split('_').length - 1], this.dateFormat)
                            .diff(moment(x.split('_')[x.split('_').length - 1], this.dateFormat));
                        });
                        this.currentIndices = data;
                        this.coverageService.getIndexTempAlias(this.currentIndices[0], this.currentIspForStatus).subscribe(
                          (data) => {
                            if (Object.keys(data).length > 0) {
                              this.solveStateWhenIndicesAreUpdated();
                            } else {
                              this.checkIndexState();
                            }
                          },
                          (error) => {
                            this.checkIndexState();
                          }
                        );
                      }
                    );
                  },
                  (error) => {
                    this.solveStateWithoutFilesLoaded();
                    return;
                  }
                );
              },
            )
          ).subscribe(
            (data) => {
              if (Object.keys(data).length > 0) {
                this.firstUsingIndex = false;
                this.currentIndexBeingUsed = Object.keys(data)[0];
                this.currentIndexTimestamp = this.currentIndexBeingUsed.split('_')[this.currentIndexBeingUsed.split('_').length - 1];
              } else {
                this.firstUsingIndex = true;
              }
            },
            (error) => {
              this.firstUsingIndex = true;
            }
          );
        }
      );
    }
  }

  public checkIndexState() {
    if ((this.currentIndexBeingUsed !== null ?
      this.currentIndexBeingUsed.split('_')[this.currentIndexBeingUsed.split('_').length - 1] !==
      this.currentIndices[0].split('_')[this.currentIndices[0].split('_').length - 1] : true)) {
      if (this.currentIndices[0].split('_')[this.currentIndices[0].split('_').length - 1] ===
        this.lastIndexTimestamp) {
        this.wildcard = 'gescal37_current_' + this.currentIspForStatus;
        this.coverageService.refreshIndices().subscribe(
          (data) => {
            this.coverageService.getIndexStats(this.wildcard).pipe(
              finalize(
                () => {
                  if (this.currentlyUsingDoc !== undefined && this.currentlyUsingDoc !== null) {
                    this.currentlyUsingDoc['indexName'] = Object.keys(this.currentlyUsingDoc.indices)[0].split('_')[1]
                      + '_' + Object.keys(this.currentlyUsingDoc.indices)[0].split('_')[2];
                  }
                  this.wildcard = this.currentIndices[0];
                  this.coverageService.getIndexStats(this.wildcard).subscribe(
                    (data) => {
                      this.lastUploadedDoc = data;
                      this.lastUploadedDoc['indexName'] = Object.keys(this.lastUploadedDoc.indices)[0];
                      this.indexState = this.indexStates.WAITING_FOR_UPDATE;
                    }
                  );
                },
              )
            ).subscribe(
              (data) => {
                this.currentlyUsingDoc = data;
              }
            );
          }
        );
      } else {
        if (!this.firstUsingIndex) {
          this.wildcard = 'gescal37_current_' + this.currentIspForStatus;
          this.coverageService.getIndexStats(this.wildcard).subscribe(
            (data) => {
              this.currentlyUsingDoc = data;
              this.currentlyUsingDoc['indexName'] = Object.keys(this.currentlyUsingDoc.indices)[0];
            }
          );
        }
        this.stateMachineCall = setTimeout(this.updateState.bind(this), 10000) as any;
      }
    }
  }

  public validateNewIndex(newIndexTimestamp, firstIndex) {
    this.coverageService.configAliases(this.getTemporalAliasQuery()).subscribe(
      (data) => {
        this.coverageService.configAliases(this.getSwapUsingAliasQuery(firstIndex)).subscribe(
          (data) => {
            this.coverageService.setMaxResultWindowIsp(this.currentIspForStatus).subscribe(
              (data) => {
                this.coverageService.getIspPriorities(this.currentIspForStatus).subscribe(
                  (data) => {
                    if (!data.priorities.includes(this.lastUploadedDoc['indexName'].split('_')[2])) {
                      this.coverageService.updateIspPriorities(this.currentIspForStatus,
                        this.getUpdatePrioritiesQuery(this.lastUploadedDoc['indexName'].split('_')[2]))
                        .subscribe(
                          (data) => {
                            this.configureHomeIdAliases(this.lastUploadedDoc.indexName.split('_')[2], newIndexTimestamp);
                          }
                        );
                    }
                    else {
                      this.configureHomeIdAliases(this.lastUploadedDoc.indexName.split("_")[2], newIndexTimestamp);
                    }
                  },
                  (error) => {
                    this.coverageService.createIspPriorities(
                      this.currentIspForStatus,
                      this.getCreatePrioritiesQuery([this.lastUploadedDoc['indexName'].split('_')[2]]))
                      .subscribe(
                        (data) => {
                          this.configureHomeIdAliases(this.lastUploadedDoc.indexName.split('_')[2], newIndexTimestamp);
                        }
                      );
                  }
                );
              }
            );
          }
        );
      }
    );
  }


  public ignoreNewIndex = function (newIndexTimestamp: string) {
    this.coverageService.configAliases(this.getTemporalAliasQuery(newIndexTimestamp)).subscribe(
      (data) => {
        this.checkIndicesAfterCharge();
      }
    );
  }

  public uploadFile() {
    if (!this.fileToUpload) {
      return;
    }
    if (!this.selectedIno) {
      return;
    }
    if (this.selectedIsps.value.length === 0) {
      return;
    }

    this.progress = 0;

    this.coverageService.uploadFile(this.selectedIsps.value, this.selectedIno, this.fileToUpload, (loaded, total) => {
      this.progress = Math.round((loaded * 100) / total);
    }).subscribe(
      (data) => {
        this.progress = 0;
        if (data && data['resultado'] !== 'NOK') {
          this.selectedIspForStateDisabled = true;
          this.indexState = this.indexStates.UPLOADING_FILE;
          this.stateMachineCall = setTimeout(this.updateState.bind(this), 1000) as any;
        }
      },
      (error) => {
        this.progress = 0;
        this.notificationsService.showNotification(
          'Ha habido un problema al subir el fichero. Por favor, vuelva a intentarlo',
          NotificationLevel.ERROR);
      });
  }

  public handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  ngOnDestroy() {
    clearTimeout(this.stateMachineCall);
  }

}
